import React from 'react';
import Ticker from './Ticker';
import Navbar from './Navbar';
import Footer from './Footer';

export default function AppLayout({ children }) {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex flex-col">
      <Ticker />
      <Navbar />
      <main className="pt-28 flex-1">{children}</main>
      <Footer />
    </div>
  );
}
